export enum DonationMode {
    TopUp = 'TopUp',
    RoundUp = 'RoundUp'
}
